import { render, staticRenderFns } from "./layout-options.vue?vue&type=template&id=b67549f4&"
import script from "./layout-options.vue?vue&type=script&lang=js&"
export * from "./layout-options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports